import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';

interface PulldownMenuProps {
    menuItems: {
        label: string;
        onClick: () => void;
    }[];
    tooltipText: string;
}

const PulldownMenu: React.FC<PulldownMenuProps> = ({ 
    menuItems, tooltipText
}) => {
    const { t } = useTranslation();
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    // Hide the menu when clicking outside of it
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setShowMenu(false);
            }
        };

        if (showMenu) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showMenu]);

    return (
        <span className='pulldown-menu-wrapper'
             style={{ position: 'relative', marginLeft: '0.3rem' }}
             ref={menuRef}>
                
            <div className='tooltip-icon edit-icon'
                 onClick={() => setShowMenu(prev => !prev)}>
                <FontAwesomeIcon icon={faEllipsis} />
                <span className='tooltip'>
                    {t(tooltipText)}
                </span>
            </div>

            {showMenu && (
                <div className='pulldown-menu'>
                    {menuItems.map((item, index) => (
                        <div className='menu-item'
                             key={index}
                             onClick={() => { item.onClick(); setShowMenu(false) }}>
                            {t(item.label)}
                        </div>
                    ))}
                </div>
            )}
        </span>
    )
}

export default PulldownMenu;